var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let LightComponentCard = class LightComponentCard extends LitElement {
    render() {
        const defaultIcon = new URL('../../assets/default_gray.svg', import.meta.url).href;
        const iconUrl = this.component.icon
            ? new URL(`../../assets/${this.component.icon}.svg`, import.meta.url).href
            : defaultIcon;
        return html `
      <basic-card
        size="small"
      >
        <div class="content">
          <img
            class="component-card__icon"
            src="${this.component.icon ? iconUrl : defaultIcon}"
            alt=${msg('Icon', { id: 'card.icon.alt', desc: "Alt text for a card's icon image" })}
          />
          <h3 class="component-card__name">${this.component.name}</h3>
          <simple-button
            special
            size="small"
            label="${msg('Add', { id: 'component.action.add', desc: 'Add component button' })}"
            @button-click="${this.handleAddToWorkflow}"
          </simple-button>
        </div>
      </basic-card>
    `;
    }
    // Nouvelle méthode pour gérer le clic du bouton
    handleAddToWorkflow() {
        if (!this.component || !this.component.key) {
            console.error('Component or component key is undefined:', this.component);
            return;
        }
        // Send event with component key
        this.dispatchEvent(new CustomEvent('add-node-workflow', {
            detail: this.component,
            bubbles: true,
            composed: true
        }));
    }
};
LightComponentCard.styles = css `
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  img {
    width: 20px;
    height: 20px;
  }

  h3 {
    flex-grow: 1;
    margin: 0 12px;
    font-size: 14px;
  }
  `;
__decorate([
    property({ type: Object })
], LightComponentCard.prototype, "component", void 0);
LightComponentCard = __decorate([
    localized(),
    customElement('light-component-card')
], LightComponentCard);
export { LightComponentCard };
//# sourceMappingURL=LightComponentCard.js.map